import React from 'react';
import { Bar } from 'react-chartjs-2';
import 'chart.js/auto';
import { Chart, CategoryScale } from 'chart.js';
import { useRapportChartSeries } from '../../Api/queriesRapport';
import LoadingSpiner from '../components/LoadingSpiner';

Chart.register(CategoryScale);

/**
 * Graphique Entrées / Sorties — optimisation :
 * avant : useAllPaiements + useAllDepenses + boucles mensuelles côté client.
 * maintenant : mêmes séries fournies par GET /api/rapport/chart-series
 * (entrée : mois de paiementDate ; sortie : mois de dateOfDepense).
 */
const BarChartEntreSortie = () => {
  const { data: series, isLoading, error } = useRapportChartSeries();

  const labels = [
    'Jan',
    'Fév',
    'Mar',
    'Avr',
    'Mai',
    'Jui',
    'Juil',
    'Aoû',
    'Sep',
    'Oct',
    'Nov',
    'Déc',
  ];

  const z = (arr) => (Array.isArray(arr) ? arr : new Array(12).fill(0));

  const data = {
    labels,
    datasets: [
      {
        label: 'Entrée (Paiements)',
        data: z(series?.entreeByMonth),
        backgroundColor: ' #328E6E',
        barThickness: 10,
      },

      {
        label: 'Sortie (Dépenses)',
        data: z(series?.sortieByMonth),
        backgroundColor: ' #CF0F47',
        barThickness: 10,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: true,
    plugins: {
      legend: {
        position: 'top',
        labels: {
          color: '#102E50',
          boxWidth: 20,
          boxHeight: 20,
        },
      },
      title: {
        display: true,
        text: 'Statistiques des Entrée, Sortie',
        color: '#102E50',
      },
    },
    interaction: {
      mode: 'index',
      intersect: false,
    },
    hover: {
      mode: 'nearest',
      intersect: true,
    },
    elements: {
      bar: {
        borderWidth: 2,
      },
    },
    layout: {
      padding: {
        top: 20,
        bottom: 20,
        left: 20,
        right: 20,
      },
    },
    animation: {
      duration: 1000,
      easing: 'easeInOutQuart',
    },
    animationSteps: 60,
    animationEasing: 'easeInOutQuart',
    responsiveAnimationDuration: 500,
    scales: {
      x: {
        grid: {
          display: false,
          drawBorder: true,
        },
        ticks: {
          color: ' #102E50',
        },
      },
      y: {
        grid: {
          drawBorder: false,
        },
        ticks: {
          color: ' #3A59D1',
        },
        beginAtZero: true,
      },
    },
  };

  if (error) {
    return (
      <div className='text-danger text-center'>
        Erreur de chargement du graphique
      </div>
    );
  }

  return (
    <React.Fragment>
      {isLoading && <LoadingSpiner />}
      <Bar width={537} height={268} data={data} options={options} />
    </React.Fragment>
  );
};

export default BarChartEntreSortie;
